<template>
  <div>
    <PageSpinner :onloader="onloader" />
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white">Dashboard</router-link>
      <router-link to="/school/examination-and-assessment" class="text-white">
        <i class="fa fa-ellipsis-v px-2"></i>Examination and Assessment Management
      </router-link>
      <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>Exam Setup</span>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="mb-5 mb-xl-0">
        <card header-classes="bg-transparent">
          <modal :show.sync="modals.questionModal" modal-classes="modal-dialog-centered modal-lg">
            <div class="card bg-secondary border-0 mb-0">
              <div class="card-body">
                <PageSpinner :onloader="onloader" />
                <div class="form-horizontal">
                  <div class="form-group">
                    <label>Question Title</label>
                    <vue-editor id="QuestionDetailsVal" v-model="QuestionDetailsVal"></vue-editor>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Exam Period (In Seconds)</label>
                        <input type="number" min="0" v-model="ExamPeriodval" class="form-control" />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>No. of Question to Display</label>
                        <input type="number" min="0" v-model="NoofQuestiontoDisplayval" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Caution Note</label>
                    <vue-editor id="CautionNoteval" v-model="CautionNoteval"></vue-editor>
                  </div>
                </div>
              </div>
            </div>
            <template slot="footer">
              <base-button type="default" @click="modals.questionModal = false">Cancel</base-button>
              <base-button type="success" @click.prevent="submitFormData">Submit</base-button>
            </template>
          </modal>
          <modal :show.sync="modals.shareQuestionModal" modal-classes="modal-dialog-centered modal-lg">
            <div class="card bg-secondary border-0 mb-0">
              <div class="card-body">
                <PageSpinner :onloader="onloader" />
                <div class="form-horizontal">
                  <div class="form-group">
                    <select v-model="ShareToRegisteredTermIdVal" class="form-control"
                      :disabled="RegisteredTerms === null">
                      <option value="0">{{ RegisteredTerms === null ? '⏳ Loading...' : '- Select Registered Term -' }}
                      </option>
                      <option v-for="item in RegisteredTerms" :key="item.registeredTermId"
                        :value="item.registeredTermId">
                        {{ item.schSession }} - {{ item.schTerm }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select v-model="ShareToClassIdval" class="form-control" @change="getShareTooptioninsubjectassigned"
                      :disabled="ShareToclassitems === null">
                      <option value="0">{{ ShareToclassitems === null ? '⏳ Loading...' : '- Select Class -' }}</option>
                      <option v-for="item in ShareToclassitems" :key="item.Id" :value="item.Id">{{ item.Sch_Class }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select v-model="ShareToOptionIdval" class="form-control" @change="GetShareToSchoolTeacherSubjects"
                      :disabled="ShareTooptionitems === null">
                      <option value="0">{{ ShareTooptionitems === null ? '⏳ Loading...' : '- Select Option -' }}
                      </option>
                      <option v-for="item in ShareTooptionitems" :key="item.Id" :value="item.Id">{{ item.ClassOption }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select v-model="ShareToSubjectIdval" class="form-control" :disabled="ShareTosubjectitems === null">
                      <option value="0">{{ ShareTosubjectitems === null ? '⏳ Loading...' : '- Select Subject -' }}
                      </option>
                      <option v-for="item in ShareTosubjectitems" :key="item.subjectId" :value="item.subjectId">{{
                        item.subjectName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <template slot="footer">
              <base-button type="default" @click="modals.shareQuestionModal = false">Cancel</base-button>
              <base-button type="success" @click.prevent="ShareSchoolQuestionAll">Submit</base-button>
            </template>
          </modal>


          <div class="cbt-filters d-flex flex-column flex-md-row align-items-stretch align-items-md-center">
            <select v-model="RegisteredTermIdVal" class="form-control" :disabled="RegisteredTerms === null">
              <option value="0">{{ RegisteredTerms === null ? '⏳ Loading...' : '- Select Registered Term -' }}</option>
              <option v-for="item in RegisteredTerms" :key="item.registeredTermId" :value="item.registeredTermId">
                {{ item.schSession }} - {{ item.schTerm }}
              </option>
            </select>
            <select v-model="ClassIdval" class="form-control" @change="getoptioninsubjectassigned"
              :disabled="ShareToclassitems === null">
              <option value="0">{{ classitems === null ? '⏳ Loading...' : '- Select Class -' }}</option>
              <option v-for="item in classitems" :key="item.Id" :value="item.Id">{{ item.Sch_Class }}</option>
            </select>
            <select v-model="OptionIdval" class="form-control" @change="GetSchoolTeacherSubjects"
              :disabled="optionitems === null">
              <option value="0">{{ optionitems === null ? '⏳ Loading...' : '- Select Option -' }}</option>
              <option v-for="item in optionitems" :key="item.Id" :value="item.Id">{{ item.ClassOption }}</option>
            </select>
            <select v-model="SubjectIdval" class="form-control" @change="GetSchoolQuestionHeader"
              :disabled="subjectitems === null">
              <option value="0">{{ subjectitems === null ? '⏳ Loading...' : '- Select Subject -' }}</option>
              <option v-for="item in subjectitems" :key="item.subjectId" :value="item.subjectId">{{ item.subjectName }}
              </option>
            </select>
            <button v-if="subjectitems" type="button" @click.prevent="openNew" class="btn btn-default">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

          <div class="table-responsive mt-2 cbt-table-wrap">
            <table class="table table-hover table-borderless table-striped cbt-table">
              <thead>
                <tr>
                  <th>Pass Code</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in cbtheaderitem" :key="item.questionHeaderId">
                  <td class="align-middle" data-label="Pass Code">{{ item.passCode }}</td>
                  <td class="align-middle cbt-details-cell" data-label="Details">
                    <div class="question-details" v-html="item.questionDetails"></div>
                    <table class="table table-sm table-bordered cbt-meta-table">
                      <thead>
                        <tr>
                          <th>No of Question to Display</th>
                          <th>Start Date</th>
                          <th>Closed Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td data-label="Questions">{{ item.noofQuestiontoDisplay }}</td>
                          <td data-label="Starts">{{ $frontEndDateFormat(item.startDate) }}</td>
                          <td data-label="Closes">{{ $frontEndDateFormat(item.closedDate) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="align-middle actions-cell" data-label="Actions">
                      <span class="actions-label">Actions</span>
                      <button v-if="item.canStart == false" class="btn btn-outline-success btn-sm"
                        title="Start Question" @click.prevent="StartSchoolQuestion(item.questionHeaderId)"><i
                          class="fa fa-play"></i><span>Start
                          Question</span></button>
                      <button v-if="item.isClosed == false" class="btn btn-outline-warning btn-sm"
                        title="Close Question" @click.prevent="edititem(item.questionHeaderId)"><i
                          class="fa fa-lock"></i><span>Close
                          Question</span></button>
                      <button class="btn btn-outline-primary btn-sm" title="Edit" @click.prevent="edititem(item)"><i
                          class="fa fa-edit"></i>Edit</button>
                      <button class="btn btn-outline-primary btn-sm" type="button"
                        @click.stop.prevent="openquestion(item.questionHeaderId)"><i class="fa fa-eye"></i><span>Questions</span></button>
                      <button class="btn btn-outline-primary btn-sm" type="button"
                        @click.stop.prevent="shareallquestion(item.questionHeaderId)"><i
                          class="fa fa-share"></i><span>Share All
                          Questions</span></button>
                      <button class="btn btn-outline-primary btn-sm" type="button"
                        @click.stop.prevent="openitemanswer(item.questionHeaderId)"><i
                          class="fa fa-users"></i><span>View Answered Questions</span></button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from '@/components/PageSpinner'
import ValidateAccessToken from '@/mixins/ValidateAccessToken.mixins'
import Alert from '@/mixins/Alert.mixins'
import DateFormater from '@/mixins/DateFormater.mixin'
import katex from 'katex'
import 'katex/dist/katex.min.css'
window.katex = katex

export default {
  name: 'questionheader',
  mixins: [ValidateAccessToken, Alert, DateFormater],
  components: { PageSpinner, VueEditor },
  data() {
    return {
      accessDetails: null,
      QuestionHeaderIdVal: 0,
      RegisteredTermIdVal: 0,
      ClassIdval: 0,
      OptionIdval: 0,
      SubjectIdval: 0,
      ShareToRegisteredTermIdVal: 0,
      ShareToClassIdval: 0,
      ShareToOptionIdval: 0,
      ShareToSubjectIdval: 0,
      QuestionDetailsVal: '',
      ExamPeriodval: '',
      CautionNoteval: '',
      NoofQuestiontoDisplayval: '',
      RegisteredTerms: null,
      classitems: null,
      optionitems: null,
      subjectitems: null,
      ShareToclassitems: null,
      ShareTooptionitems: null,
      ShareTosubjectitems: null,
      cbtheaderitem: null,
      isModified: false,
      onloader: 'none',
      modals: {
        questionModal: false,
        shareQuestionModal: false
      },
      openMenuId: null
    }
  },
  methods: {
    openNew() {
      this.QuestionHeaderIdVal = 0
      this.ExamPeriodval = ''
      this.CautionNoteval = ''
      this.NoofQuestiontoDisplayval = ''
      this.QuestionDetailsVal = ''
      this.isModified = false
      this.modals.questionModal = true
    },
    openquestion(id) { localStorage.setItem('SchcbtheaderId', id); this.$router.push('/school/examination-and-assessment/cbt-questions') },
    openitemanswer(id) { localStorage.setItem('SchcbtheaderId', id); this.$router.push('/school/examination-and-assessment/cbt-answers') },
    shareallquestion(id) {
      this.QuestionHeaderIdVal = id;
      this.modals.shareQuestionModal = true;
    },
    toggleMenu(id) { this.openMenuId = this.openMenuId === id ? null : id },
    closeMenu() { this.openMenuId = null },
    edititem(item) {
      if (typeof item === 'number') item = { questionHeaderId: item }
      this.QuestionHeaderIdVal = item.questionHeaderId
      this.ExamPeriodval = item.examPeriod || ''
      this.CautionNoteval = item.cautionNote || ''
      this.NoofQuestiontoDisplayval = item.noofQuestiontoDisplay || ''
      this.QuestionDetailsVal = item.questionDetails || ''
      this.isModified = true
      this.modals.questionModal = true
    },
    submitFormData() {
      if (!this.RegisteredTermIdVal || !this.SubjectIdval || !this.QuestionDetailsVal) return this.ShowAlertWarning('Please complete the required fields', '')
      const examPeriod = parseInt(this.ExamPeriodval, 10)
      const questionCount = parseInt(this.NoofQuestiontoDisplayval, 10)
      if (isNaN(examPeriod) || examPeriod < 0 || isNaN(questionCount) || questionCount <= 0) return this.ShowAlertWarning('Enter valid exam period and question count', '')
      const data = { QuestionDetails: this.QuestionDetailsVal, RegisteredTermId: this.RegisteredTermIdVal, SubjectId: this.SubjectIdval, ExamPeriod: examPeriod, CautionNote: this.CautionNoteval, NoofQuestiontoDisplay: questionCount }
      if (this.isModified) data.QuestionHeaderId = this.QuestionHeaderIdVal
      this.onloader = 'flex'
      this.$store.dispatch(this.isModified ? 'SchoolQuestion/UpdateSchoolQuestionHeader' : 'SchoolQuestion/CreateSchoolQuestionHeader', data).then(resp => {
        this.onloader = 'none'
        if (resp.responseCode === '00') { this.modals.questionModal = false; this.GetSchoolQuestionHeader(); this.ShowAlertSuccess(resp.data, '') } else this.ShowAlertError(resp.responseMessage, '')
      }).catch(err => { this.onloader = 'none'; this.ShowAlertError(err.response && err.response.data ? err.response.data : err.message, '') })
    },
    StartSchoolQuestion(id) { this.runQuestionAction('SchoolQuestion/StartSchoolQuestion', id) },
    CloseSchoolQuestion(id) { this.runQuestionAction('SchoolQuestion/CloseSchoolQuestion', id) },
    runQuestionAction(action, id) {
      this.onloader = 'flex'
      this.$store.dispatch(action, { QuestionHeaderId: id }).then(resp => { this.onloader = 'none'; if (resp.responseCode === '00') { this.GetSchoolQuestionHeader(); this.ShowAlertSuccess(resp.data, '') } else this.ShowAlertError(resp.responseMessage, '') }).catch(err => { this.onloader = 'none'; this.ShowAlertError(err.response && err.response.data ? err.response.data : err.message, '') })
    },
    ShareSchoolQuestionAll() {
      if (!this.ShareToSubjectIdval || !this.ShareToRegisteredTermIdVal) return
      this.onloader = 'flex'
      this.$store.dispatch('SchoolQuestion/ShareSchoolQuestionAll', { questionHeaderId: this.QuestionHeaderIdVal, toSubjectId: this.ShareToSubjectIdval, toRegisteredTermId: this.ShareToRegisteredTermIdVal }).then(resp => {
        if (resp.responseCode === '00') {
          this.ShowAlertSuccess(resp.responseMessage, '')
        } else {
          this.ShowAlertError(resp.responseMessage, '')
        }
        this.onloader = 'none';
      }).catch(err => { this.onloader = 'none'; this.ShowAlertError(err.response && err.response.data ? err.response.data : err.message, '') })
    },
    GetSchoolQuestionHeader() {
      if (!this.SubjectIdval || !this.RegisteredTermIdVal) return
      this.onloader = 'flex'
      this.$store.dispatch('SchoolQuestion/GetSchoolQuestionHeader', { SubjectId: this.SubjectIdval, RegisteredTermId: this.RegisteredTermIdVal }).then(resp => { this.cbtheaderitem = resp.responseCode === '00' ? resp.data : []; this.onloader = 'none' }).catch(err => { this.onloader = 'none'; this.ShowAlertError(err.response && err.response.data ? err.response.data : err.message, '') })
    },
    GetPortalRegisteredTerm() {
      this.$store.dispatch('PortalSchoolSessionTerm/GetPortalRegisteredTerm', {
        SearchValue: null, PageNumber: 1, PageSize: 1000
      }).then(resp => {
        this.RegisteredTerms = resp.data;       
      }).catch(() => { this.RegisteredTerms = [] })
    },

    getclassinsubjectassigned() {
      this.classitems = null;
      this.optionitems = null;
      this.subjectitems = null;
      this.cbtheaderitem = null;
      this.ShareToclassitems = null;
      this.ShareTooptionitems = null;
      this.ShareTosubjectitems = null;
      this.ClassIdval = 0;
      this.$store.dispatch('getclassinsubjectassigned').then(resp => {
        this.classitems = resp;
        this.ShareToclassitems = resp;
      }).catch(() => { this.classitems = [] })
    },
    getoptioninsubjectassigned() {
      this.optionitems = null;
      this.subjectitems = null;
      this.cbtheaderitem = null;
      this.OptionIdval = 0;
      if (this.ClassIdval > 0)
        this.$store.dispatch('getoptioninsubjectassigned', this.ClassIdval).then(resp => {
          this.optionitems = resp
        }).catch(() => {
          this.optionitems = []

        })
    },
    getShareTooptioninsubjectassigned() {
      this.ShareTooptionitems = null;
      this.ShareTosubjectitems = null;
      this.ShareToOptionIdval = 0;
      if (this.ShareToClassIdval > 0)
        this.$store.dispatch('getoptioninsubjectassigned', this.ShareToClassIdval).then(resp => {
          this.ShareTooptionitems = resp
        }).catch(() => {
          this.ShareTooptionitems = []

        })
    },
    GetSchoolTeacherSubjects() {
      this.subjectitems = null;
      this.cbtheaderitem = null;
      this.SubjectIdval = 0;
      if (this.OptionIdval > 0)
        this.$store.dispatch('PortalSchoolSubject/GetSchoolTeacherSubjects', this.OptionIdval).then(resp => {
          this.subjectitems = resp.responseCode === '00' ? resp.data : []
        }).catch(() => { this.subjectitems = [] })
    },
    GetShareToSchoolTeacherSubjects() {
      this.ShareTosubjectitems = null;
      this.ShareToSubjectIdval = 0;
      if (this.ShareToOptionIdval > 0)
        this.$store.dispatch('PortalSchoolSubject/GetSchoolTeacherSubjects', this.ShareToOptionIdval).then(resp => {
          this.ShareTosubjectitems = resp.responseCode === '00' ? resp.data : []
        }).catch(() => { this.ShareTosubjectitems = [] })
    }
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user']
    if (this.accessDetails && this.accessDetails.isSchoolStaff === false) { this.$store.dispatch('auth/Logout'); this.$router.push('/login'); return }
    this.GetPortalRegisteredTerm()
    this.getclassinsubjectassigned()
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy() { document.removeEventListener('click', this.closeMenu) }
}
</script>

<style scoped>
.cbt-filters {
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.cbt-filters .form-control {
  flex: 1 1 0;
  min-width: 0;
}

.table-responsive {
  width: 100%;
  overflow-x: auto !important;
  overflow-y: visible;
}

.cbt-table-wrap {
  border: 1px solid #e9ecef;
  border-radius: 0.65rem;
  background: #fff;
  box-shadow: 0 0.35rem 1rem rgba(50, 50, 93, 0.06);
}

.cbt-table {
  min-width: 920px;
  margin-bottom: 0;
}

.cbt-table>thead {
  background: #f8fafc;
}

.cbt-table>thead th {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #e9ecef;
  color: #525f7f;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cbt-table>tbody>tr {
  transition: background-color 0.18s ease;
}

.cbt-table>tbody>tr:hover {
  background: #fbfcfe;
}

.cbt-table>tbody>tr>td {
  padding: 1rem;
  border-top: 1px solid #edf0f5;
  color: #344767;
}

.cbt-table>tbody>tr>td:first-child {
  width: 13rem;
  color: #172b4d;
  font-weight: 700;
  white-space: nowrap;
}

.question-details {
  margin-bottom: 0.85rem;
  color: #344767;
  line-height: 1.55;
}

.question-details :last-child {
  margin-bottom: 0;
}

.cbt-meta-table {
  min-width: 0;
  margin-bottom: 1rem;
  background: #fbfcfe;
}

.cbt-meta-table th {
  color: #8898aa;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
}

.cbt-meta-table td,
.cbt-meta-table th {
  padding: 0.55rem 0.65rem;
  vertical-align: middle;
}

.table-responsive td {
  overflow-wrap: anywhere;
}

.table-responsive td p {
  margin-bottom: 0;
}

.actions-cell {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.5rem, 1fr));
  gap: 0.45rem;
  min-width: 190px;
}

.actions-label {
  grid-column: 1 / -1;
  color: #8898aa;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.actions-cell .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 2.15rem;
  margin: 0;
  white-space: normal;
  text-align: center;
}

.actions-cell .btn i {
  flex: 0 0 auto;
}

.exam-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding: 0.3rem;
  border: 1px solid #e9ecef;
  border-radius: 0.75rem;
  background: #f8f9fa;
  box-shadow: 0 2px 8px rgba(50, 50, 93, 0.08);
}

.exam-actions>.btn,
.action-menu-button {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
  padding: 0;
}

.exam-actions .btn:hover,
.exam-actions .btn:focus,
.action-menu-button[aria-expanded="true"] {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(50, 50, 93, 0.16);
}

.action-toggle-wrap {
  position: relative;
  display: inline-flex;
}

.action-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  width: 235px;
  z-index: 1100;
  padding: 0.4rem;
  overflow: hidden;
  border: 1px solid #e9ecef;
  border-radius: 0.65rem;
  background: #fff;
  box-shadow: 0 12px 30px rgba(50, 50, 93, 0.18), 0 3px 8px rgba(0, 0, 0, 0.08);
}

.action-dropdown-title {
  padding: 0.45rem 0.65rem 0.35rem;
  color: #8898aa;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.action-dropdown button {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.65rem;
  padding: 0.6rem 0.65rem;
  border: 0;
  border-radius: 0.45rem;
  background: transparent;
  color: #344767;
  font-size: 0.82rem;
  text-align: left;
}

.action-dropdown button i {
  width: 1rem;
  color: #5e72e4;
  text-align: center;
}

.action-dropdown button:hover,
.action-dropdown button:focus {
  outline: 0;
  background: #f6f9fc;
  color: #172b4d;
}

@media (max-width: 576px) {

  .cbt-filters .form-control,
  .cbt-filters .btn {
    width: 100%;
    margin: 0;
  }

  .cbt-table-wrap {
    overflow: visible !important;
    border: 0;
    background: transparent;
    box-shadow: none;
  }

  .cbt-table-wrap>.cbt-table>thead {
    display: none;
  }

  .cbt-table-wrap>.cbt-table,
  .cbt-table-wrap>.cbt-table>tbody,
  .cbt-table-wrap>.cbt-table>tbody>tr,
  .cbt-table-wrap>.cbt-table>tbody>tr>td {
    display: block;
    width: 100%;
    min-height: 2rem;
  }

  .cbt-table-wrap>.cbt-table {
    min-width: 0;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr {
    margin-bottom: 0.75rem;
    border: 1px solid #e9ecef;
    border-radius: 0.65rem;
    background: #fff;
    box-shadow: 0 0.35rem 1rem rgba(50, 50, 93, 0.06);
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td {
    padding: 0.8rem 0.9rem;
    border: 0;
    border-bottom: 1px solid #f1f3f5;
    text-align: left;
    position: relative;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td::before {
    content: attr(data-label) ": ";
    display: block;
    margin-bottom: 0.25rem;
    font-weight: 600;
    color: #495057;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td:first-child {
    width: 100%;
    white-space: normal;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td:last-child {
    border-bottom: 0;
  }

  .cbt-meta-table {
    display: block;
    border: 1px solid #e9ecef;
    border-radius: 0.45rem;
    overflow: hidden;
  }

  .cbt-meta-table thead {
    display: none;
  }

  .cbt-meta-table tbody,
  .cbt-meta-table tbody tr,
  .cbt-meta-table tbody td {
    display: block;
    width: 100%;
  }

  .cbt-meta-table tbody tr {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .cbt-meta-table tbody td {
    padding: 0.55rem 0.45rem;
    border: 0;
    border-right: 1px solid #e9ecef;
    text-align: center;
    font-size: 0.78rem;
  }

  .cbt-meta-table tbody td::before {
    content: attr(data-label);
    display: block;
    margin-bottom: 0.15rem;
    color: #8898aa;
    font-size: 0.62rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  .cbt-meta-table tbody td:last-child {
    border-right: 0;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td.actions-cell {
    text-align: left;
  }

  .cbt-table-wrap>.cbt-table>tbody>tr>td.actions-cell::before {
    display: block;
    float: none;
    margin-bottom: 0.25rem;
  }

  .actions-cell .btn {
    min-width: 0;
  }

  .exam-actions {
    width: 100%;
    justify-content: flex-start;
    padding: 0.4rem;
  }

  .action-dropdown {
    width: min(235px, calc(100vw - 3rem));
  }
}

@media (max-width: 380px) {
  .actions-cell {
    grid-template-columns: 1fr;
  }
}
</style>
